import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ClipboardActionType = 'copy' | 'cut' | null;

export interface ClipboardItem {
  id: string;
  type: 'file' | 'folder';
  name: string;
}

export interface ClipboardState {
  items: ClipboardItem[];
  actionType: ClipboardActionType;
  sourceFolder: string | null;
}

const initialState: ClipboardState = {
  items: [],
  actionType: null,
  sourceFolder: null,
};

export const clipboardSlice = createSlice({
  name: 'clipboard',
  initialState,
  reducers: {
    copyToClipboard: (
      state,
      action: PayloadAction<{ items: ClipboardItem[]; sourceFolder: string }>
    ) => {
      state.items = action.payload.items;
      state.actionType = 'copy';
      state.sourceFolder = action.payload.sourceFolder;
    },
    cutToClipboard: (
      state,
      action: PayloadAction<{ items: ClipboardItem[]; sourceFolder: string }>
    ) => {
      state.items = action.payload.items;
      state.actionType = 'cut';
      state.sourceFolder = action.payload.sourceFolder;
    },
    clearClipboard: (state) => {
      state.items = [];
      state.actionType = null;
      state.sourceFolder = null;
    },
  },
});

export const { copyToClipboard, cutToClipboard, clearClipboard } = clipboardSlice.actions;

export default clipboardSlice.reducer; 